module.exports = __webpack_public_path__ + "img/baseline_insert_drive_file_black_24dp.5c03877d.svg";